<template>
  <div class="picto-wrapper tw-relative tw-flex tw-items-end tw-justify-center">
    <div class="tw-absolute tw-flex tw-h-full tw-w-full tw-flex-col tw-text-bridgit-mayaBlue-50">
      <svg
        class="tw-flex-initial"
        width="100%"
        viewBox="0 0 256 107"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 106.123H256V322.554C256 329.181 250.627 334.554 244 334.554H12C5.37258 334.554 0 329.181 0 322.554V106.123Z"
          fill="currentColor"
        />
        <path
          d="M195.61 27.4154C195.61 25.2063 197.401 23.4154 199.61 23.4154H230.995C233.204 23.4154 234.995 25.2063 234.995 27.4154V92.9949H195.61V27.4154Z"
          fill="currentColor"
        />
        <path
          d="M256 106.338L134.55 2.41862C130.83 -0.806205 125.251 -0.806205 121.45 2.41862L0 106.338H256Z"
          fill="currentColor"
        />
      </svg>
      <svg
        class="tw-flex-1"
        width="100%"
        preserveAspectRatio="none"
        viewBox="0 0 256 137"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 -0.876953H256V215.554C256 222.181 250.627 227.554 244 227.554H12C5.37258 227.554 0 222.181 0 215.554V-0.876953Z"
          fill="currentColor"
        />
      </svg>
      <svg class="tw-flex-initial" width="100%" viewBox="0 0 256 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M0 -216.877H256V-0.446193C256 6.18122 250.627 11.5538 244 11.5538H12C5.37258 11.5538 0 6.18123 0 -0.446182V-216.877Z"
          fill="currentColor"
        />
      </svg>
    </div>
    <div class="tw-z-[1]">
      <slot></slot>
    </div>
  </div>
</template>

<script setup lang="ts"></script>

<style lang="scss" scoped>
.picto-wrapper {
  transition: width 250ms, height 250ms;
}
</style>
